'use client';

import React from 'react';
import Breadcrumb from '@/components/ui/Breadcrumb';
import { SectionStack } from '@/components/ui/SectionStack';
import { AdviserToolkit } from '@/features/b2b/resources/components/marketing-toolkit/AdviserToolkit';
import { NewFeatures } from '@/features/b2b/resources/components/marketing-toolkit/NewFeatures';
import { Footer } from '@/features/b2b/resources/components/marketing-toolkit/Footer';
import { Hero } from '@/features/b2b/resources/components/marketing-toolkit/Hero';
import { MarketingAtFingerTips } from '@/features/b2b/resources/components/marketing-toolkit/MarketingAtFingerTips';
import { ResourcesSlider } from '@/features/b2b/resources/components/marketing-toolkit/ResourcesSlider';
import {
  MarketingAtFingerTipsDesktop
} from '@/features/b2b/resources/components/marketing-toolkit/MarketingAtFingerTipsDesktop';
import { ReadyMadeResources } from '@/features/b2b/resources/components/marketing-toolkit/ReadyMadeResources';
import { GetStartedSteps } from '@/features/b2b/resources/components/marketing-toolkit/GetStartedSteps';

const breadcrumbItems = [
  {
    label: 'Resources',
    labelMobile: '...',
    href: '/professionals/resources',
  },
  { label: 'Marketing toolkit', href: '/professionals/resources/marketing-toolkit' },
];

export const MarketingToolkit = () => (
  <SectionStack>
    <div>
      <div className="container mx-auto">
        <div className="pt-3">
          <Breadcrumb items={breadcrumbItems}/>
        </div>
      </div>
      <Hero />
    </div>
    {/* Mobile and tablet version of "Marketing at your fingertips": heading plus slider in one slot */}
    <div className="lg:hidden">
      <MarketingAtFingerTips />
      <ResourcesSlider />
    </div>
    <MarketingAtFingerTipsDesktop />
    <ReadyMadeResources />
    <GetStartedSteps />
    <NewFeatures />
    <AdviserToolkit />
    <Footer />
  </SectionStack>
);
